// extracted by mini-css-extract-plugin
export default {"container":"AiContentTip_container__A9Isc"};